window.theme = window.theme || {};
function debounce(func) {
      var timer;
      return function(event) {
          if (timer) clearTimeout(timer);
          timer = setTimeout(func, 100, event);
      };
  }

$(document).ready(function() {

    $('body').on('click','.section-header .reputon-google-reviews-widget', function(e) {
    e.preventDefault();
    const url = 'https://www.google.com/maps/place/Progressive+Desk+-+Adjustable+Standing+Desks/@48.1592342,-122.1510385,17z/data=!3m1!4b1!4m6!3m5!1s0x54855156266e149d:0x84305e096c34a66d!8m2!3d48.1592342!4d-122.1510385!16s%2Fg%2F11h5n8rp17?entry=ttu';
    window.open(url,'_blank');
  });
  
    $(".hbspt-form-quote-trigger").on("click",function(a){a.preventDefault(),$.fancybox.open({src:"#hbspt-form-quote",type:"inline",width:"100%",height:"auto",opts:{afterShow:function(){}}})});


      if($('.custom-featured-mobile-grid').length) {
   $('.custom-featured-mobile-grid').each(function(index,mobile_gridWrapper) {
      const $parentGrid = $(this).closest('.custom-featured-grid-blocks');
      const desktopBlocks = $parentGrid.find('.custom-featured-grid .custom-featured-block');
     if(desktopBlocks.length) {
       for(let i=1;i <= desktopBlocks.length;i++) {
         let image_block = $parentGrid.find('.image_block[data-image_index="'+i+'"]');
         let text_block = $parentGrid.find('.text_block[data-text_index="'+i+'"]');

         if(image_block.length) {
           let image_clone = image_block.clone(true);
           $(mobile_gridWrapper).append(image_clone);
         }
           if(text_block.length) {
           let text_clone = text_block.clone(true);
           $(mobile_gridWrapper).append(text_clone);
         }
         
       }
     }
   });
  }
  

  $('body').on('click','.footer-block__heading', function(e) {     
       const windowWidth = $(window).width();
     if (windowWidth < 991) {
        e.preventDefault();
        e.stopPropagation();
      $(this).toggleClass('active');
      $(this).next('.footer-block__details-content').slideToggle(500);
     }
  });
  
  $('body').on('click', '.sign-mod-nav-list .trigger', function(e){
    e.preventDefault();

    $(this).closest('.login-panel').find('.col').hide();
    $(''+$(this).attr('href')).show();
  });
  

   const topButton = document.getElementById('topButton');
  let scrollHeight = Math.max(
    document.body.scrollHeight, document.documentElement.scrollHeight,
    document.body.offsetHeight, document.documentElement.offsetHeight,
    document.body.clientHeight, document.documentElement.clientHeight
  );
  window.addEventListener('scroll', function() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > (scrollHeight / 3)) {
      topButton.classList.add('show');
    } else {
      topButton.classList.remove('show');
    }
  });
  topButton.addEventListener('click', (e)=>{
    e.preventDefault();
    window.scrollTo(0, 0);
  })
  
   $("body").on("click", '.prev-warranty__item-block > .prev-warranty__item-tab', function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).next().slideUp(400);
    } else {
      $(this).addClass("active");
      $(this).next().slideDown(400);
    }
  })
  

     function setTabBorderPosition(elem) {
     const parentEl = elem.closest('.bamboo_tabs--content');
     const active_navEl = parentEl.querySelector('.nav-link.active');
     const TabBorder = parentEl.querySelector('.TabBorder');
     
     let tabBorder_offsetLeft = TabBorder.offsetLeft;
     let offsetWidth = active_navEl.offsetWidth;
     let offsetLeft = active_navEl.offsetLeft;

     offsetLeft = offsetLeft - tabBorder_offsetLeft;
     
     elem.style.setProperty('--tab-border-active-left', `${offsetLeft}px`);
      elem.style.setProperty('--tab-border-active-width', `${offsetWidth}px`);
   }
     const TabBorderActiveArr = document.querySelectorAll('.TabBorderActive');
 
   if(TabBorderActiveArr.length) {
     for(const tabBorderEl of TabBorderActiveArr) {
       setTabBorderPosition(tabBorderEl);

        window.addEventListener("resize", debounce(function(e) {
              setTabBorderPosition(tabBorderEl);
         }));
     }
   }
  

    $('body').on('click', '.nav-tabs a', function(e) {
        e.preventDefault();

      const $parentEl = $(this).closest('.bamboo_tabs--content');
       $parentEl.find('.nav-tabs a').removeClass('active show');
        $parentEl.find('.tab-content .tab-pane').removeClass('active show');
        $($(this).attr('href')).addClass('active show');
        $(this).addClass('active show');

      const tabBorderEl = $parentEl[0].querySelector('.TabBorderActive');
      if(tabBorderEl) {
        setTabBorderPosition(tabBorderEl);
      }
    });

    $('body').on('click', '.mobile-tab', function(e) {
        e.preventDefault();
        $(this).toggleClass('active show');
        var target_content = $(this).next('.mobile-pane');
        if (target_content) {
            target_content.slideToggle('fast', function() {
                target_content.toggleClass('active show');
            });
        }
    });

    function productSliderBamboo() {

        var selectors = {
            productThumbs: '.bamboo-section-slider .product-single__thumbnails',
            mainSlider: '.bamboo-section-slider .images-slider--mobile',
            productThumbImages: '.product-single__thumbnail',
            productImageWraps: '.product-single__photo'
        };

        var settings = {
            mediaQueryMediumUp: 'screen and (min-width: 1200px)',
            mediaQuerySmall: 'screen and (max-width: 575px)',
            sliderActive: false,
            sliderMobileActive: false
        };


        function checkMobileSlider() {
            if (window.matchMedia(settings.mediaQuerySmall).matches) {
                _initSliderImagesMobile();
            } else {
                _destroySliderImagesMobile();
            }
        }

        checkMobileSlider();

        window.addEventListener("resize", debounce(function(e) {
            checkMobileSlider();
        }));



        // enquire.register(settings.mediaQuerySmall, {
        //   match: function() {
        //     _initSliderImagesMobile();
        //   },
        //   unmatch: function() {
        //     if (settings.sliderMobileActive) {
        //       _destroySliderImagesMobile();
        //     }
        //   }
        // });

        _initThumbnailSlider();
        _initImageSwitch();
        _setActiveThumbnail();

        function _initImageSwitch() {
            $(selectors.productThumbImages).on('click mouseover', function(evt) {
                evt.preventDefault();
                var $el = $(this);

                var imageId = $el.data('thumbnail-id');

                _switchImage(imageId);
                _setActiveThumbnail(imageId);
            });

            $('.product-single__thumbnails .slick-arrow').on('mouseover', function() {
                $(this).trigger('click');
            });

            $(selectors.mainSlider).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                var imageId = $(selectors.mainSlider).find('.slick-slide[data-slick-index="' + nextSlide + '"]').find('.product-single__photo').data('image-id');
                _setActiveThumbnail(imageId);
            });
        }

        function _setActiveThumbnail(imageId) {
            var activeClass = 'active-thumb';

            // If there is no element passed, find it by the current product image
            if (typeof imageId === 'undefined') {
                imageId = $(selectors.productImageWraps + ":not('.hide')").data('image-id');
            }

            var $thumbnail = $(selectors.productThumbImages + "[data-thumbnail-id='" + imageId + "']");
            $(selectors.productThumbImages).removeClass(activeClass).removeAttr('aria-current');

            $thumbnail.addClass(activeClass);
            $thumbnail.attr('aria-current', true);
        }

        function _switchImage(imageId) {
            var $newImage = $(selectors.productImageWraps + "[data-image-id='" + imageId + "']");
            var $otherImages = $(selectors.productImageWraps + ":not([data-image-id='" + imageId + "'])");

            $newImage.removeClass('hide');
            $otherImages.addClass('hide');
        }

        function _initThumbnailSlider() {

            var options = {
                slidesToShow: 5,
                slidesToScroll: 1,
                infinite: false,
                arrows: true,
                prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;"><path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5 c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"/></svg></button>',
                nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;"><path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5 c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"/></svg></button>',
                vertical: true,
                responsive: [{
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 4,
                            infinite: true,
                            arrows: false,
                            vertical: false,
                            asNavFor: selectors.mainSlider,
                            focusOnSelect: true,
                            variableWidth: true
                        }
                    },
                    {
                        breakpoint: 400,
                        settings: {
                            slidesToShow: 3,
                            infinite: true,
                            arrows: false,
                            vertical: false,
                            asNavFor: selectors.mainSlider,
                            focusOnSelect: true,
                            variableWidth: true
                        }
                    }
                ]
            };

            $(selectors.productThumbs).slick(options);

            // Accessibility concerns not yet fixed in Slick Slider
            $(selectors.productThumbsWrapper).find('.slick-list').removeAttr('aria-live');
            $(selectors.productThumbsWrapper).find('.slick-disabled').removeAttr('aria-disabled');

            settings.sliderActive = true;
        }

        function _initSliderImagesMobile() {
            var self = this;
            var options = {
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;"><path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5 c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"/></svg></button>',
                nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;"><path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5 c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"/></svg></button>',
                asNavFor: selectors.productThumbs,
                responsive: [{
                    breakpoint: 576,
                    settings: 'unslick'
                }]
            };


            $(selectors.mainSlider).slick(options);

            $('.slick-arrow').click(function() {
                var currentSlide = $(selectors.mainSlider).slick('slickCurrentSlide');
                $(selectors.productThumbs).slick('slickGoTo', currentSlide, true);
            });

            settings.sliderMobileActive = true;
        }

        function _destroyThumbnailSlider() {
            $(this.selectors.productThumbs).slick('unslick');
            this.settings.sliderActive = false;

            // Accessibility concerns not yet fixed in Slick Slider
            $(this.selectors.productThumbsWrapper, this.$container)
                .find('[tabindex="-1"]')
                .removeAttr('tabindex');
        }

        function _destroySliderImagesMobile() {
            $(selectors.sliderImagesMobile).slick('unslick');
            settings.sliderMobileActive = false;
        }

    }
    productSliderBamboo();

    $('body').on('click',".color_wrapper", function() {
        var color = $(this).data('color');

        $('.color_wrapper').removeClass('active');
        $('.image_grommet.corner').removeClass('active');
        $(this).addClass('active');
        var images = $(this).closest('.product-desk-variants').find('.image_container .image_top');
        var bambooBlocks = $(this).closest('.product-desk-variants').find('.bamboo-image-block');
        images.removeClass('active');
        $.each(images, function() {
            //$(this).removeClass('active');
            if ($(this).data('title') == color) {
                $(this).addClass('active');
            }
        });

        if (bambooBlocks.length > 0) {
            bambooBlocks.removeClass('active');
            $.each(bambooBlocks, function() {
                if ($(this).data('title') == color) {
                    $(this).addClass('active');
                }
            });
        }
        if ($('.image_container .image_top.active').length == 1) {
            $('.image_grommet.entire').addClass('active');
        } else {
            $('.image_grommet.not-entire').addClass('active');
        }
    });

    $(window).resize(function() {
        mobileSliders();
    });
    mobileSliders();

    function mobileSliders() {
        if ($(window).width() <= 992) {
            $('.slider-products-image').slick({
                asNavFor: $('.section-image .section-image-wrapper'),
                dots: true,
                arrows: true,
                prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;"><path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5 c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"/></svg></button>',
                nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;"><path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5 c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"/></svg></button>'
            });
            $('.section-image .section-image-wrapper').slick({
                dots: false,
                arrows: false
            });
        } else {
            if ($('.slider-products-image').hasClass('slick-slider')) {
                $('.slider-products-image').slick('unslick');
            }
            if ($('.section-image .section-image-wrapper').hasClass('slick-slider')) {
                $('.section-image .section-image-wrapper').slick('unslick');
            }
        }
    }
    $('body').on('click', '.section-products-wrapper .product-image', function() {
        $('.section-products-wrapper .product-image').removeClass('active');
        $(this).addClass('active');
        var index = $(this).attr('data-index');
        $('.gaming-products').find('.main-image').removeClass('active');
        $('.gaming-products').find('.main-image[data-index="' + index + '"]').addClass('active');
    });


    var videoEle = document.getElementById("bgvid");
    $('body').on("click", "#btn-sound", function() {
        $('.btn-sound-icon').toggleClass('active');
        if (!videoEle.muted) {
            videoEle.muted = true;
        } else {
            videoEle.muted = false;
            videoEle.play();
        }
    })

    if (videoEle) {
        videoEle.onpause = () => {
            videoEle.onplay(function() {
                videoEle.play();
                videoEle.muted = false;
            });
        }
    }

    if ($('#resources_page').length > 0 || $('.faq-page').length > 0) {
        $("body").on("click","#resources_page .blog-tab-nav a", function(e) {
            e.preventDefault();
            $("#resources_page .blog-tab-nav a").removeClass('active');
            $(this).toggleClass('active');
            var tab_id = $(this).attr('href').replace('#', '');
            $("#resources_page .tab-content.active").fadeOut(400, function() {
                $("#resources_page .tab-content").removeClass('active');
                $('.tab-content[data-id="' + tab_id + '"]').fadeIn(400, function() {
                    $('.tab-content[data-id="' + tab_id + '"]').addClass('active');
                });
            });
        });
        if (window.location.hash != "") {
            $('#resources_page .blog-tab-nav a[href="' + window.location.hash + '"]').trigger("click");
        }
        $(window).on("hashchange", function() {
            $('#resources_page .blog-tab-nav a[href="' + window.location.hash + '"]').trigger("click");
        });
        function covtime(youtube_time) {
            var array = youtube_time.match(/(\d+)(?=[MHS])/ig) || [];
            if (array.length < 2 && youtube_time.indexOf('M') == -1) {
                array.unshift('0');
            }
            var arrLength = array.length;
            var formatted = array.map(function(item, i) {
                if (i == arrLength - 1 && youtube_time.indexOf('S') > -1) {
                    if (item.length < 2) return '0' + item;
                }
                return item;
            }).join(':');
            return formatted;
        }
        $('.resources__video-item .during-time').each(function(i) {
            var videoId = $(this).data('video-id');
            resourcesVideoDuration($(this), videoId);

            function resourcesVideoDuration(video_item, videoId) {
                var ytApiKey = "AIzaSyDIlbB24yHCFDckgr7tGr0KHjM_I6JZ-zM";
                $.get("https://www.googleapis.com/youtube/v3/videos?part=contentDetails&id=" + videoId + "&key=" + ytApiKey, function(data) {
                    var youtube_time = data.items[0].contentDetails.duration;
                    var duration = covtime(youtube_time);
                    video_item.find('.d-time').html(duration);
                });
            }
        });
    }
      $("body").on("click", ".resources__item-block > .resources__item-tab", function() {

         const is_tabs__button_toggle_media = $(this).hasClass('tabs__button_toggle_media');
        
            if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this).next().slideUp(400);
            } else {
                $(this).addClass("active");
                $(this).next().slideDown(400);

              if(is_tabs__button_toggle_media) {
                const image_url = $(this).attr('data-tab_image');
                const video_url = $(this).attr('data-tab_video');
                const $parentTabEl = $(this).closest('.tab-pane');
                const $tabImageEl = $parentTabEl.find('.tab__media_block img');
                const $tabVideoEl = $parentTabEl.find('.tab__media_block video');
                
                if(image_url) {
                  if($tabImageEl.length) {
                    $tabImageEl.attr('src',image_url);
                    $tabImageEl.attr('srcset',image_url);
                    $tabImageEl.removeClass('hide');
                  }
                  if($tabVideoEl.length) {
                    $tabVideoEl.addClass('hide');
                  }
                }

                  if(video_url) {
                  if($tabImageEl.length) {
                    $tabImageEl.addClass('hide');
                  }
                  if($tabVideoEl.length) {
                    $tabVideoEl.attr('src',video_url);
                    $tabVideoEl.removeClass('hide');
                  }
                }
                
                
              }
            }
        
         
            
        })
    $("body").on("click", ".blog-content .btn-load-more", function(e) {
        e.preventDefault();
        LoadMoreBlog();
    });

    function LoadMoreBlog(num) {
        var totalNum = $(".blog__item.active-item").length;
        var totalPagNumber = parseInt(totalNum / 12);
        var prePagination = $(".pro-auto__pagination");
        if (prePagination == undefined) {
            return false;
        }
        var query = 'page';
        if ($('body').hasClass('template-blog')) {
            query = 'view';
        }
        var nextPageHref = prePagination.find('.btn-load-more').attr('href');
        var nextPageNum = parseInt(nextPageHref.split(query + '=')[1]);
        if (num != undefined) {
            nextPageNum = parseInt(num);
        }
        var counter = nextPageNum * 12;

        $(".blog__item.active-item").each(function(i) {
            var el = $(this);
            if (i >= counter) return false;
            if (el.is(':hidden')) {
                el.fadeIn();

            }
        });
        if ($(".blog__item.active-item:hidden").length == 0) {
            setParam(query, totalPagNumber);
            prePagination.hide();
            prePagination.find('.btn-load-more').attr('href', nextPageHref.split(query + '=')[0] + +query + '=' + totalPagNumber);
        } else {

            setParam(query, nextPageNum);
            prePagination.show();
            prePagination.find('.btn-load-more').attr('href', nextPageHref.split(query + '=')[0] + query + '=' + (nextPageNum + 1));
        }
    }
    if ($('body').hasClass('template-blog')) {
      if( $('.blog-tabs-wrap').length) {
        $(window).on("scroll", function() {
            var $window = $(this);
            if ($window.width() > 768) {
                var sectionTabs = $('.blog-tabs-wrap');
                var sideBar = $('.side-wrap');
                var windowTop = $window.scrollTop() + $('.site-header').height();
                if (windowTop > sectionTabs.parent().offset().top) {
                    $(".tabs-placeholder").height(sectionTabs.outerHeight());
                    sectionTabs.addClass('fixed');
                } else {
                    sectionTabs.removeClass('fixed');
                    $(".tabs-placeholder").height(0);
                }
            }

        });
      }
    }

    function setParam(key, value) {
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + key + '=' + value;
        window.history.replaceState({
            path: newurl
        }, '', newurl);
    }
    if ($('body').hasClass('page-blog')) {
        if (window.location.href.indexOf('?page=') > -1) {
            var pageNum = (window.location.href).split('?page=')[1];
            LoadMoreBlog(pageNum);
        }

    }

//   theme.CollectionCustomGrid = (function(container) {
//   var config = {
//     mediaQuerySmall: 'screen and (max-width: 1100px)',
//     mediaQueryMediumUp: 'screen and (min-width: 1101px)'
//   };

//   var _this= this;

//   function CollectionCustomGrid(container) {

 
//     var _this= this;
//     var $container = (_this.$container = $(container));
//     var sectionId = $container.attr('data-section-id');
//     var slider = (_this.slider = '.grid-view-item__image-container');
//     var sliderCompare = (_this.sliderCompare = '.swiper-container--compare');
//     var $slider = $(slider, $container);
//     var $compareBtn = $('.btn--compare', $container);
//     var sliderOptions = {
//       dots: true,
//       arrows: true,
//       fade: true,
//       slidesToScroll: 1,
//       slidesToShow: 1,
//       infinite: false,
//       responsive: [
//         {
//           breakpoint: 768,
//           settings: {
//             fade: false
//           }
//         }
//       ]
//     };


//         function checkMobileSlider() {
//             if (window.matchMedia(config.mediaQuerySmall).matches) {
//             initSlider($slider, sliderOptions);
//             initCompareSlider();
//             }
//         }


//     function checkDesktopSlider() {
//       if (window.matchMedia(config.mediaQueryMediumUp).matches) {
//          destroySlider();
//         if ($(sliderCompare, $container).find('.list-view-item--compare').length > 4) {
//           initCompareSlider();
//         } else {
//           destroyCompareSlider();
//         }
//       }
//     }

//         checkMobileSlider();
//         checkDesktopSlider();    
    
//         window.addEventListener("resize", debounce(function(e) {
//             checkMobileSlider();
//           checkDesktopSlider()
//         }));
    

//     $(this.slider, this.$container).on('beforeChange', beforeChange.bind(this));
//     window.onresize = function(event) {
//       if ($(_this.slider, _this.$container).hasClass('slick-initialized')) {
//         $(_this.slider, _this.$container).closest('.product-card--list').removeClass('active');
//         $(_this.slider, _this.wrapper).slick('slickGoTo', 0);
//       }
//       if (_this.mySwiper != undefined && $(sliderCompare, $container).hasClass('swiper-container-initialized')) {
//         _this.mySwiper.update();
//       }
//     };

//     $compareBtn.click(function() {
//       $(this).toggleClass('open').next().slideToggle('fast');
      

//       if (window.matchMedia(config.mediaQuerySmall).matches) {

//          if (_this.mySwiper != undefined && $(sliderCompare, $container).hasClass('swiper-container-initialized')) {
//             _this.mySwiper.update();
//           } else {
//             initCompareSlider();
//           }
   
//       }
      
//     });
//   }


//     function initSlider(sliderObj, args) {
//       if (!sliderObj.hasClass('slick-initialized')) {
//         sliderObj.slick(args);
//       }
//     }

//     function destroySlider()  {
//       if ($(_this.slider, _this.$container).hasClass('slick-initialized')) {
//         $(_this.slider, _this.$container).slick('unslick');
//       }
//     }

//     function initCompareSlider() {
    
//       if (typeof new Swiper != undefined && !$(sliderCompare, $container).hasClass('swiper-container-initialized')) {
//         _this.mySwiper = new Swiper(sliderCompare, {
//           direction: 'horizontal',
//           loop: false,
//           slidesPerView: 'auto',
//           spaceBetween: 8,
//           centeredSlides: false,
//           freeMode: true,
//           pagination: {
//             el: '.swiper-pagination-dots',
//             clickable: true,
//             renderBullet: function (index, className) {
//               return '<span class="' + className + '">' + (index + 1) + '</span>';
//             },
//           },
//           scrollbar: {
//             el: '.swiper-scrollbar',
//             hide: false,
//           },
//           breakpoints: {
//             1101: {
//               spaceBetween: 30
//             }
//           }
//         });
//       }
//     }

//     function destroyCompareSlider() {
//       if (typeof new Swiper != undefined && $(sliderCompare, $container).hasClass('swiper-container-initialized')) {
//         _this.mySwiper.destroy();
//       }
//     }

//     function beforeChange(event, slick, currentSlide, nextSlide) {
//       if ($(_this.slider, _this.$container).hasClass('slick-initialized')) {
//         let sliderList = $(event.currentTarget).closest('.product-card--list');
//         if (nextSlide == 1) {
//           sliderList.addClass('active');
//         } else {
//           sliderList.removeClass('active');
//         }
//       }
//     }

//     function onBlockSelect(evt) {
//       // Ignore the cloned version
//       var $slide = $(
//         '.slide--' + evt.detail.blockId + ':not(.slick-cloned)'
//       );
//       var slideIndex = $slide.data('slick-index');

//       // Go to selected slide, pause autoplay
//       $(_this.slider, _this.wrapper).slick('slickGoTo', slideIndex);
//     }
 

//   return CollectionCustomGrid(container);
// });

//   if($('[data-section-type="collection-template-custom-grid-products"]').length) {
//     theme.CollectionCustomGrid('[data-section-type="collection-template-custom-grid-products"]');
//   }

    $('body').on('change', ".form-question-wrap input", function (e) {
    $('.form-wrap').toggleClass('active');
  });


    $('body').on("click", ".volume-btn", function(e) {
       e.preventDefault();
       if($("#hbspt-form-volume").children().length <= 0){
         hbspt.forms.create({
           region: "na1",
           portalId: "7717445",
           formId: "cce14700-1cd3-4579-9fb6-04780da9f99e",
           target: "#hbspt-form-volume"
         });
       }
       $.fancybox.open({
          src  : '#hbspt-form-volume',
          type : 'inline',
          width : '100%',
          height : 'auto',
          opts : {}
       });
     });

  $('.gaming-quotes-slider').slick({
  dots: true,
  speed: 300,
  slidesToScroll: 1,
  arrows: false,
  slidesToShow: 1,
  autoplay: false
});

  
    $('body').on("click", ".gb-form-button", function(e) {
      e.preventDefault();
      $.fancybox.open({
         src  : '#group-buy-form',
         type : 'inline',
         width : '100%',
         height : 'auto',
         opts : {}
      });
    });
    $('body').on("click", ".steps_button_sec_btn", function(e) {
      e.preventDefault();
      $.fancybox.open({
         src  : '#group-buy-form',
         type : 'inline',
         width : '100%',
         height : 'auto',
         opts : {}
      });
    });

    const iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
    '.custom__item-inner--html iframe[src*="player.vimeo"]';
  
     const $iframes =  $(iframeSelectors);
      if($iframes.length) {
          $iframes.each(function() {
          $(this).wrap('<div class="' + 'video-wrapper' + '"></div>');
          this.src = this.src;
        });
      }


    let timeDelay = 40000;
  function checkAcceptCookies(){
    if(typeof getCookie != 'undefined') {
    setTimeout( function(){
      if(!getCookie("promotions-popup") && ($('#promotions-popup-wrapper').length > 0)) {
        setCookie('promotions-popup', true, 1);
        $('#promotions-popup-wrapper').addClass('open');
        $('body').addClass('popup-open');

        
       if($('.promotions-popup-video').length) {
         
         if($('.promotions-popup-video').hasClass('with__autoplay')) {
            $('.promotions-popup-video')[0].muted = true;
            $('.promotions-popup-video')[0].play();
         }
    }
        
      }
    }, timeDelay );
    }
  };
  checkAcceptCookies();
   let timerId;
  if($('#promotions-popup-wrapper').length > 0) {
    let showPopupBeforeCloseWindow = false;

    let timerCount = 0;
     timerId = setInterval(function () {
      timerCount += 1000;
      if(timerCount >= timeDelay) {
        showPopupBeforeCloseWindow = true;
        clearInterval(timerId);
      }
    }, 1000);

     if(!getCookie("promotions-popup")) {
        $("body").mouseleave(function() {
    if(showPopupBeforeCloseWindow == false && timerCount <= timeDelay) {
     $('#promotions-popup-wrapper').addClass('open');
      $('body').addClass('popup-open');
        
       if($('.promotions-popup-video').length) {
         if($('.promotions-popup-video').hasClass('with__autoplay')) {

            $('.promotions-popup-video')[0].muted = true;
            $('.promotions-popup-video')[0].play();
         }
    }
      
      showPopupBeforeCloseWindow = true;
      clearInterval(timerId);
       setCookie('promotions-popup', true, 1);
    }
    });
     }
  }

  $('body').on('click', '.promotions-popup-close', function (ev) {
    ev.preventDefault();
    $('#promotions-popup-wrapper').removeClass('open');

    if($('.promotions-popup-video').length) {
      $('.promotions-popup-video')[0].pause();
      $('.promotions-popup-video')[0].currentTime = 0;
    }
    $('body').removeClass('popup-open');
     showPopupBeforeCloseWindow = true;
      clearInterval(timerId);
  });

  // $('body').on('click','.promotions-popup-link', function (ev) {
  //   ev.preventDefault();
  //   $('#promotions-popup-wrapper').removeClass('open');
  //   $('body').removeClass('popup-open');
  //   window.location.href = theme.promoPopupLink;
  // });

    const relatedProductsSlider = () => {
    const prodSliderWrap = $(".pd-recommendations-ul.pd-temp--product");
    const cartProdSliderWrap = $(".cart__footer .pd-recommendations-ul");
    const collProdSliderWrap = $(".pd-recommendations-ul.pd-temp--collection");
    const sliderWrap = prodSliderWrap.length
      ? prodSliderWrap
      : cartProdSliderWrap.length
      ? cartProdSliderWrap
      : undefined;
    const slideLength = $(".pd-recommendations-ul li").length;
    const productTemp = prodSliderWrap.length || collProdSliderWrap.length;
    const mobSlider = window.innerWidth < 581 && slideLength > 1;
    const middleScreen = productTemp ? 1025 : 1300;
    const tabletSlider = window.innerWidth < middleScreen && slideLength > 2; 
    const cartPrevArrow = $(".pd-prev-opt.pd-prev-opt--cart");
    const cartNextArrow = $(".pd-next-opt.pd-next-opt--cart");
    const prodtPrevArrow =
      '<div class="pd-prev-opt pd-prev-opt--recommend"></div>';
    const prodNextArrow =
      '<div class="pd-next-opt pd-next-opt--recommend"></div>';
  
      if (sliderWrap == undefined) {
      return false;
    } else {
      if (slideLength > 3 || tabletSlider || mobSlider) {
        sliderWrap.slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          nextArrow: productTemp ? prodNextArrow : cartNextArrow,
          prevArrow: productTemp ? prodtPrevArrow : cartPrevArrow,
          responsive: [
            {
              breakpoint: productTemp ? 1025 : 1300,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 1,
                centerMode: true,
              },
            },
          ],
        });
      }
    }
  };

  if($(".pd-recommendations-ul.pd-temp--product").length) {
    relatedProductsSlider();
  }
      $('body').on('click','.js--link-to-section', function(e) {
        e.preventDefault();
        $('html, body').stop().animate({
            scrollTop: $($(this).attr('href')).offset().top
        }, 1000);
    });

// if($('.ShopTheLook .ShopTheLook__Item').length > 1) {
//      const options = {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 infinite: true,
//                 arrows: true,
//                 nextArrow: '<button class="slick-next  slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="31" viewBox="0 0 17 31" fill="none"><path d="M1.5 29L14.2929 16.2071C14.6834 15.8166 14.6834 15.1834 14.2929 14.7929L1.5 2" stroke="white" stroke-width="3" stroke-linecap="round"/></svg></button>',
//                 prevArrow: '<button class="slick-prev slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="31" viewBox="0 0 17 31" fill="none"><path d="M15.5 2L2.70711 14.7929C2.31658 15.1834 2.31658 15.8166 2.70711 16.2071L15.5 29" stroke="white" stroke-width="3" stroke-linecap="round"/></svg></button>'
//             };
//   $('.ShopTheLook').slick(options);
// }

  if($('.ShopTheLook').length) {

  document.addEventListener('click', function(e){
  	let el = e.target;
    if(el.classList.contains('ShopTheLook__Dot') || el.closest('.ShopTheLook__Dot')) {
      if(!el.classList.contains('ShopTheLook__Dot')) {
      	el = el.closest('.ShopTheLook__Dot');
      }

      e.preventDefault();

      const windowWidth = window.innerWidth;
      if(windowWidth <= 1024) {


      const ShopTheLookSectionWrapper = el.closest('.ShopTheLook');
        
      const ShopTheLook__DotsWrapperEl = el.closest('.ShopTheLook__DotsWrapper'); 
      const prevActiveEl = ShopTheLook__DotsWrapperEl.querySelector('.ShopTheLook__ProductWrapper.is-active');
      let prevActiveEl_Index = null;
      if(prevActiveEl) {
        prevActiveEl.classList.remove('is-active');
        prevActiveEl_Index = prevActiveEl.getAttribute('data-product-index') * 1;

        ShopTheLookSectionWrapper.classList.remove('active_dot');
      }
      
      const parentEl = el.closest('.ShopTheLook__ProductWrapper');
      if(parentEl) {
        let parentEl_Index = parentEl.getAttribute('data-product-index') * 1;
        if(parentEl_Index != prevActiveEl_Index) {
          parentEl.classList.toggle('is-active');

          if(parentEl.classList.contains('is-active')) {
             ShopTheLookSectionWrapper.classList.add('active_dot');
          } else {
             ShopTheLookSectionWrapper.classList.remove('active_dot');
          }
         
        }
      }
        
     
      }
    }
  });    
  document.addEventListener('click', function(e){
  	let el = e.target;
    
    if(el.classList.contains('ShopTheLook__Product__close_btn') || el.closest('.ShopTheLook__Product__close_btn')) {
      if(!el.classList.contains('ShopTheLook__Product__close_btn')) {
      	el = el.closest('.ShopTheLook__Product__close_btn');
      }

      e.preventDefault();
       const parentEl = el.closest('.ShopTheLook__ProductWrapper');
      const ShopTheLookSectionWrapper = el.closest('.ShopTheLook');
      
      if(parentEl) {
        parentEl.classList.toggle('is-active');
        ShopTheLookSectionWrapper.classList.remove('active_dot');
        }
    }
  });    
    
    const isItIn = function(parent, child) {
      const box1coords = parent.getBoundingClientRect();
      const box2coords = child.getBoundingClientRect();
  
      let isOverlap = false;
      let overlapSide = {};
  
  
      if(box2coords.top < box1coords.top) {
        overlapSide.top = true;
        isOverlap = true;
      } 
     if(box2coords.right > box1coords.right) {
        overlapSide.right = true;
         isOverlap = true;
       } 
      if(box2coords.left < box1coords.left) {
        overlapSide.left = true;
         isOverlap = true;
      } 
      if(box2coords.bottom > box1coords.bottom) {
        overlapSide.bottom = true;
         isOverlap = true;
      }
  
      if(isOverlap) {      
        return overlapSide;
      } else {
        return false;
      }
    
    
  }
    function ShopTheLook__ProductReposition() {
      const ShopTheLook__ProductArr = document.querySelectorAll('.ShopTheLook__Product');
      if(ShopTheLook__ProductArr.length) {
        ShopTheLook__ProductArr.forEach(function(item,index) {
    
           item.classList.remove('repositioned');
           item.classList.remove('top');
           item.classList.remove('left');
           item.classList.remove('right');
           item.classList.remove('bottom');
          
          const parentEl = item.closest('.ShopTheLook__Item');
          if(isItIn(parentEl,item)) {
            const response = isItIn(parentEl,item);
    
            for (key in response) {
              item.classList.add(key);
            }
            item.classList.add('repositioned');
          } 
        });
      }
    }
    ShopTheLook__ProductReposition();
    window.addEventListener("resize", debounce(function(e) {
            ShopTheLook__ProductReposition();
  }));


  document.addEventListener('click', function(e){
  	let el = e.target;
    if(el.classList.contains('ShopTheLook__modal_btn') || el.closest('.ShopTheLook__modal_btn')) {
      if(!el.classList.contains('ShopTheLook__modal_btn')) {
      	el = el.closest('.ShopTheLook__modal_btn');
      }

      e.preventDefault();
       const modalId = el.getAttribute('data-href-id');
      const modalEl = document.querySelector('#'+modalId);
      
      if(modalEl) {
        modalEl.classList.add('active');
        document.body.classList.add('popup-open');
        }
    }
  }); 

  document.addEventListener('click', function(e){
  	let el = e.target;
    if(el.classList.contains('ShopTheLook__modal_close') || el.closest('.ShopTheLook__modal_close')) {
      if(!el.classList.contains('ShopTheLook__modal_close')) {
      	el = el.closest('.ShopTheLook__modal_close');
      }

      e.preventDefault();
      const modalEl = el.closest('.ShopTheLook__modal');
      if(modalEl) {
        modalEl.classList.remove('active');
        document.body.classList.remove('popup-open');
        }
    }
  }); 
    
  }
  
});



document.addEventListener("DOMContentLoaded", function() {
  const collaborations_footer_blockEl = document.querySelector('.collaborations_footer_block');
  if(collaborations_footer_blockEl) {
    const collabs_page__ctaEl =  document.querySelector('.collabs-page__main .collabs-page__intro .collabs-page__cta');
    if(collabs_page__ctaEl) {
      collaborations_footer_blockEl.appendChild(collabs_page__ctaEl);

      const collabs_page__cta_mainEl = document.querySelector('.collabs-page__cta-main');
      if(collabs_page__cta_mainEl) {
        const collapsMainWrapperEl = document.querySelector('.collabs-page__main');
        if(collapsMainWrapperEl) {
          collapsMainWrapperEl.appendChild(collabs_page__cta_mainEl);
        }
      }

    }
  }

  const article_podcast_audioEl = $('.article_podcast_audio audio')[0];
 if(article_podcast_audioEl) {
  article_podcast_audioEl.addEventListener('play', function (e) {
      const toggle_play_podcast_btnArr = document.querySelectorAll('.toggle_play_podcast_btn');
    if(toggle_play_podcast_btnArr.length) {
      for(const toggle_play_podcast_btn of toggle_play_podcast_btnArr) {
        toggle_play_podcast_btn.classList.add('active');
      }
    }
  });
  article_podcast_audioEl.addEventListener('pause', function (e) {
      const toggle_play_podcast_btnArr = document.querySelectorAll('.toggle_play_podcast_btn');
    if(toggle_play_podcast_btnArr.length) {
      for(const toggle_play_podcast_btn of toggle_play_podcast_btnArr) {
        toggle_play_podcast_btn.classList.remove('active');
      }
    }
  });
  
  $('body').on('click','.toggle_play_podcast_btn', function (e) {
      e.preventDefault();

      const articleWrapperEl = $(this).closest('article');
      if(articleWrapperEl.length) {
        const article_podcast_audioEl = articleWrapperEl.find('.article_podcast_audio audio')[0];
        if(article_podcast_audioEl) {
          $(this).toggleClass('active');
          let isActiveBtn = $(this).hasClass('active');

          if(isActiveBtn) {
          article_podcast_audioEl.play();
          } else {
            article_podcast_audioEl.pause();
          }
        }
      }
  });
 }

  function isScrolledIntoView(elem) {
    let docViewTop = $(window).scrollTop();
    let docViewBottom = docViewTop + $(window).height();

    let elemTop = $(elem).offset().top;
    let elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }
  if(document.querySelector('.look-section-wrapper')) {

  let setScrollEvent = true;
  const window_width = window.innerWidth;
  const look_wrapperEl = document.querySelector('.look-section-wrapper');
  const last_look__text_block = look_wrapperEl.querySelector('.look__text_block:last-child');
    
  if(window_width > 767) {
      if(isScrolledIntoView(last_look__text_block)) {
          look_wrapperEl.classList.add('visible_section');
      setScrollEvent = false;
  }
    if(setScrollEvent) {
    $(window).on('scroll.view_look_section', function() {
      if(isScrolledIntoView(last_look__text_block)) {
          look_wrapperEl.classList.add('visible_section');
           $(window).off('scroll.view_look_section');
        }
    });
    } 
  } else {
       look_wrapperEl.classList.add('visible_section');
    } 
  }

  $('body').on('change','.tab_pane_swatch', function(e) {
    const is_checked = this.checked;
    console.log(is_checked);
    const image_url = this.value;
    const parentEl = this.closest('.tab-pane');
    const tab__mediaEl = parentEl.querySelector('.tab__media_block img');

    console.log(tab__mediaEl);
    console.log(image_url);
    const tab__videoEl = parentEl.querySelector('.tab__media_block video');
    if(tab__mediaEl) {
      tab__mediaEl.src = image_url;
      tab__mediaEl.srcset = image_url;
      tab__mediaEl.classList.remove('hide');
    }
    if(tab__videoEl) {
      tab__videoEl.classList.add('hide');
    }
  });
  const headerEl = document.querySelector('sticky-header');
  if(headerEl) {
    const headerStickyType = headerEl.getAttribute('data-sticky-type');
    
    if(document.querySelector('.main-content .shop-the-look-section:first-child') || headerStickyType != 'on-scroll-up') {
      document.body.classList.remove('homepage_overlay_header');
     document.body.classList.add('always-active-header-sticky');
    }
  } else {
     document.body.classList.remove('homepage_overlay_header');

      const staticHeader = document.querySelector('.site-header');
      const megamenu_childlink_sliderArr = staticHeader.querySelectorAll('.megamenu-childlink_slider'); 
      const mega_menu__slidesArr = staticHeader.querySelectorAll('.mega-menu__slide_blocks_wrapper');
    
      if(mega_menu__slidesArr.length) {
        for(const mega_menu__slider of mega_menu__slidesArr) {
          const mega_menu__slide_blocksArr = mega_menu__slider.querySelectorAll('.mega-menu__slide_block');
          if(mega_menu__slide_blocksArr.length > 3) {

                let options = {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                arrows: true, 
                autoplay:false,
                nextArrow: '<button class="slick-next  slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="31" viewBox="0 0 17 31" fill="none"><path d="M1.5 29L14.2929 16.2071C14.6834 15.8166 14.6834 15.1834 14.2929 14.7929L1.5 2" stroke="white" stroke-width="3" stroke-linecap="round"/></svg></button>',
                prevArrow: '<button class="slick-prev slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="31" viewBox="0 0 17 31" fill="none"><path d="M15.5 2L2.70711 14.7929C2.31658 15.1834 2.31658 15.8166 2.70711 16.2071L15.5 29" stroke="white" stroke-width="3" stroke-linecap="round"/></svg></button>'
              };

            mega_menu__slider.classList.add('enable_slider');
            $(mega_menu__slider).slick(options);
           
          }
        }
      }
      if(megamenu_childlink_sliderArr.length) {
        for(const megamenu_childlink_slider of megamenu_childlink_sliderArr) {
          const megamenu_childlink_sliderBlocksArr = megamenu_childlink_slider.querySelectorAll('.mega-menu__slide_block');
          if(megamenu_childlink_sliderBlocksArr.length > 3) {

                let options = {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                arrows: true, 
                autoplay:false,
                nextArrow: '<button class="slick-next  slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="31" viewBox="0 0 17 31" fill="none"><path d="M1.5 29L14.2929 16.2071C14.6834 15.8166 14.6834 15.1834 14.2929 14.7929L1.5 2" stroke="white" stroke-width="3" stroke-linecap="round"/></svg></button>',
                prevArrow: '<button class="slick-prev slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="31" viewBox="0 0 17 31" fill="none"><path d="M15.5 2L2.70711 14.7929C2.31658 15.1834 2.31658 15.8166 2.70711 16.2071L15.5 29" stroke="white" stroke-width="3" stroke-linecap="round"/></svg></button>'
              };

            megamenu_childlink_slider.classList.add('enable_slider');
            $(megamenu_childlink_slider).slick(options);
           
          }
        }
      }

      const mega_menusArr = staticHeader.querySelectorAll('.header__inline-menu .mega-menu');
      if(mega_menusArr.length) {
        for(const mega_menu of mega_menusArr) {
           mega_menu.addEventListener('mouseenter', function(e) {
          document.body.classList.add('megamenu-active');
        });
        mega_menu.addEventListener('mouseleave', function(e) {
          document.body.classList.remove('megamenu-active');
        });
        }
      }
      const grandchild_mega_menu_links = staticHeader.querySelectorAll('.grandchild-mega_menu_link');
      if(grandchild_mega_menu_links.length) {
        for(const grandchild_mega_menu_link of grandchild_mega_menu_links) {

          const grandchild_mega_menu_link__handle = grandchild_mega_menu_link.getAttribute('data-handle');
          const parentMenuEl = grandchild_mega_menu_link.closest('.mega-menu__content');
          const megamenu_childlink_slider = parentMenuEl.querySelector(`.megamenu-childlink_slider[data-handle="${grandchild_mega_menu_link__handle}"]`);

                grandchild_mega_menu_link.addEventListener('mouseenter', function(e) {

                 
                  const prev_active_megamenu_childlink_slider = parentMenuEl.querySelector('.mega-menu__content .megamenu-childlink_slider.active');
                  const prev_active_link = parentMenuEl.querySelector('.active_slider_link');
                  if(prev_active_link) {
                   prev_active_link.classList.remove('active_slider_link');
                  }
                  if(prev_active_megamenu_childlink_slider) {
                    const prev_active_megamenu_childlink_slider__Handle = prev_active_megamenu_childlink_slider.getAttribute('data-handle');
                    if(prev_active_megamenu_childlink_slider__Handle != grandchild_mega_menu_link__handle) {
                      prev_active_megamenu_childlink_slider.classList.remove('active');
                    }
                  }
                if(megamenu_childlink_slider) {
              
                  this.classList.add('active_slider_link');
                  megamenu_childlink_slider.classList.add('active');
                  parentMenuEl.classList.add('active_grandchild_slider');
                } else {
                   parentMenuEl.classList.remove('active_grandchild_slider');
                }
              });
        
       
        }
      }
  }
  
    $('body').on('click','.anchor_link_elem',function (e) {
        e.preventDefault();
    const $elemID = $(this).attr('data-anchorId');
    const $elem = $($elemID);
    if($elem.length) {
       const header_height = parseFloat(document.documentElement.style.getPropertyValue('--header-height'));
       const announcement_height = parseFloat(document.documentElement.style.getPropertyValue('--announcement-bar-height'));
      
        $("html, body").animate({
          scrollTop: ($elem.offset().top - header_height - announcement_height)
          }, 1e2);
    }
  });

    $('body').on('click','.hbspt_trigger_btn', function(e) { 
      e.preventDefault();
    const el_ID = $(this).attr('href');
      $.fancybox.open({
        src  : el_ID,
        type : 'inline',
        width : '100%',
        height : 'auto',
        opts : {
          afterShow : function( ) {

          }
        }
      });
    });
    $('body').on('click','.collapsible_usp_icon', function(e) {
    e.preventDefault();
    $(this).toggleClass('active');
  });


  $('body').on('click','.discount_promo_tab_btn', function(e) {
    e.preventDefault();

    const promoId = $(this).attr('data-block-id');
    const promoBlockEl = $('#'+promoId);
    const filterId = $(this).attr('data-filter-id');
    const $products_gridArr = $('#product-grid > .grid__item');
    
    const prevActiveTab_btn = $(this).closest('.tabs-section').find('.discount_promo_tab_btn.active');
    const prevActiveTab_btnId = prevActiveTab_btn.attr('data-block-id');

      prevActiveTab_btn.removeClass('active');
      $('#'+prevActiveTab_btnId).removeClass('show_promo_info');
     

    if($products_gridArr.length) {
      $products_gridArr.each(function(index,product_grid) {
        const product_grid_FilterId = $(product_grid).attr('data-discount_promo_filter');
        if(product_grid_FilterId == filterId) {
          $(product_grid).removeClass('hide');
        } else {
           $(product_grid).addClass('hide');
        }
      });
    }

     $(this).addClass('active');    
      promoBlockEl.addClass('show_promo_info');
   

    
  });
    if($('.discount_promo_tab_btn').length) {
    $('.discount_promo_tab_btn').first().click();
  }

  $('body').on('click','.announcement-bar_copy_btn',function(e) {
    e.preventDefault();
    const $this = $(this);
    const copied_text = $this.attr('data-copy_text');
    const original_btn_text = $this.attr('data-original-text');
   
    
    navigator.clipboard.writeText(copied_text).then(function() {
     $this.html('COPIED');
      setTimeout(function() {
        $this.html(original_btn_text);
      }, 2000);
    }, function(err) {
        console.error("Помилка копіювання:", err);
    });
  });

      if(window.location.href.indexOf('#anchor__') >= 0) {
    const anchorBtnId = window.location.href.split('#anchor__')[1];
    const anchorBtnEl = document.querySelector('#anchor_btn__'+anchorBtnId);
    if(anchorBtnEl) {
      anchorBtnEl.click();
      window.history.pushState({}, document.title, window.location.pathname ); 
    }
  }

    if(theme.subscribePopupEnable){
    if (theme.subscribePopup) {
      if(window.location.pathname=='/'){
        openSubscribePopup();
      }
    }else{
      openSubscribePopup();
    }
  }
  function openSubscribePopup() {
    $(window).scroll(function() {
      var win_h = $(window).height();
      if(!getCookie("subscribe-popup")) {
        if (win_h <= $(this).scrollTop()) {
          setCookie("subscribe-popup", true, 1);
       
          $.fancybox.open({
            src  : '#hbspt-form-subscribe',
            type : 'inline',
            width : '100%',
            height : 'auto',
          });
        }
      }
    });
  };

  
  function closeCustomPopup (el) {
  const popupEl = el.closest('.custom-popup-form');
  if(popupEl) {
  popupEl.classList.remove('open');
  document.body.classList.remove('custom_popup_opened');
  }
  }
  document.addEventListener('click', function(e){
  let el = e.target;
     if(el.classList.contains('custom-popup-overlay') || el.closest('.custom-popup-overlay')) {
  e.preventDefault();    
  closeCustomPopup(el);
     }
  });
  document.addEventListener('click', function(e){
  let el = e.target;
  if(el.classList.contains('custom-popup-form-close-btn') || el.closest('.custom-popup-form-close-btn')) {
  if(!el.classList.contains('custom-popup-form-close-btn')) {
  el = el.closest('.custom-popup-form-close-btn');
  }
  e.preventDefault();    
  closeCustomPopup(el);
  }
  });
  document.addEventListener('click', function(e){
  let el = e.target;
  if(el.classList.contains('custom_popup_btn') || el.closest('.custom_popup_btn')) {
  if(!el.classList.contains('custom_popup_btn')) {
  el = el.closest('.custom_popup_btn');
  }
  e.preventDefault();
  const popupId = el.getAttribute('href');
  const popupEl = document.querySelector(popupId);
  if(popupEl) {
   popupEl.classList.add('open');
  document.body.classList.add('custom_popup_opened');
  }
  }
  });

   $("body").on("click", ".dynamic_accordions_with_media .tabs__button", function(e) {
    e.stopPropagation();
    // e.preventDefault();

       const is_tabs__button_toggle_media = $(this).hasClass('tabs__button_toggle_media');
    
    if (!$(this).hasClass("tabs__button--active")) {
      $(this).siblings(".tabs__button--active").removeClass("tabs__button--active");
        const parentTabsEl = $(this).closest('.tab_content_block');
        const prevActiveTabBtn = parentTabsEl.find(".tabs__button--active");
        if(prevActiveTabBtn.length) {
          prevActiveTabBtn.removeClass("tabs__button--active");
          prevActiveTabBtn.next(".tabs__item").slideUp(400);
        }
      if ($(this).parents(".tabs--wide").length) {
        $(this).siblings(".tabs__item:visible").slideUp(400);
        $(this).next(".tabs__item").slideDown(400);
      } else {
        $(this).siblings(".tabs__item:visible").slideUp(400);
        $(this).next(".tabs__item").slideDown(400);
      }
      $(this).addClass("tabs__button--active");
    } else if ($(this).hasClass("tabs__button--active")) {
      $(this).removeClass("tabs__button--active");
      $(this).next(".tabs__item").slideUp(400);
    }

    if(is_tabs__button_toggle_media) {
      const image_url = $(this).attr('data-tab_image');
      const $parentEl = $(this).closest('.image_with_accordions_wrapper');
      const $sectionImageEl = $parentEl.find('.section__media_block img');
      
      if(image_url) {
        if($sectionImageEl.length) {
          $sectionImageEl.attr('src',image_url);
          $sectionImageEl.attr('srcset',image_url);
          $sectionImageEl.removeClass('hide');
        }
      }         
    }
  });

      const featured_video_grid_section = document.querySelector('.featured-video-grid-section');
  if(featured_video_grid_section) {
    const featured_video_grid_section_videosArr = featured_video_grid_section.querySelectorAll('video');

    featured_video_grid_section_videosArr.forEach((video, index) => {

      video.setAttribute('data-index',index);
      
      video.addEventListener('ended', function(e) {
        const parentEl = this.closest('.featured-video-block');
        const el_index = parseInt(this.getAttribute('data-index'));
        const block_btn = parentEl.querySelector('.toggle-video-btn');

        if(block_btn) {
          block_btn.classList.remove('active');
        }
        parentEl.classList.remove('active_block');

        const videoGridWrapper = this.closest('.featured-video-grid');        
        let nextVideoEl = videoGridWrapper.querySelector(`video[data-index="${el_index+1}"`);

        if(!nextVideoEl) {
          nextVideoEl = featured_video_grid_section_videosArr[0];
        }
          if(nextVideoEl) {
              nextVideoEl.play();
          }
        
      });
       video.addEventListener('play', function(e) {
     
        const parentEl = this.closest('.featured-video-block');
        const block_btn = parentEl.querySelector('.toggle-video-btn');

        parentEl.classList.add('active_block');
        if(block_btn) {
          block_btn.classList.add('active');
        }
       });
    });
    
     document.addEventListener('click', function(e){
    	let el = e.target;
      if(el.classList.contains('toggle-video-btn') || el.closest('.toggle-video-btn')) {
      if(!el.classList.contains('toggle-video-btn')) {
      	el = el.closest('.toggle-video-btn');
      }
      e.preventDefault();
     
      const sectionParent = el.closest('.featured-video-grid');
      const prevActiveVideoBlock = sectionParent.querySelector('.active_block');
      let prevActiveVideoBlockIndex = null;
      if(prevActiveVideoBlock) {
         prevActiveVideoBlockIndex = prevActiveVideoBlock.getAttribute('data-index');
      } 

      const parentMediaEl = el.closest('.featured-video-block');
      const parentMediaElIndex = parentMediaEl.getAttribute('data-index');
      
      if(parentMediaElIndex  != prevActiveVideoBlockIndex && prevActiveVideoBlockIndex != null) {
     
        prevActiveVideoBlock.classList.remove('active_block');
        const prevActiveVideoEl = prevActiveVideoBlock.querySelector('video');
        const prevActiveVideoBlockBtn = prevActiveVideoBlock.querySelector('.toggle-video-btn');
        if(prevActiveVideoEl) {
          prevActiveVideoEl.pause();
        }
        if(prevActiveVideoBlockBtn) {
          prevActiveVideoBlockBtn.classList.remove('active');
        }
      }
      
      const videoEl = parentMediaEl.querySelector('video');
      el.classList.toggle('active');
       
      if(el.classList.contains('active')) {
          parentMediaEl.classList.add('active_block');
        videoEl.play();
      } else {
         parentMediaEl.classList.remove('active_block');
        videoEl.pause();       
      }
    }
      });
  }

  
  $('body').on('click','.height-calculator--btn', function(e) {
  e.preventDefault();
  
  const heightData = {
    "5'0": { sitting: "22.5\"", standing: "36.5\"", chair: "15.5\"", monitor: "45.5\"", monitor_standing: "59.5\"" },
    "5'1": { sitting: "23\"", standing: "37\"", chair: "16\"", monitor: "46\"", monitor_standing: "60\"" },
    "5'2": { sitting: "23\"", standing: "37.5\"", chair: "16\"", monitor: "46.5\"", monitor_standing: "60.5\"" },
    "5'3": { sitting: "23.5\"", standing: "38\"", chair: "16.5\"", monitor: "47\"", monitor_standing: "61\"" },
    "5'4": { sitting: "24\"", standing: "39\"", chair: "17\"", monitor: "47.5\"", monitor_standing: "62\"" },
    "5'5": { sitting: "24.5\"", standing: "39.5\"", chair: "17\"", monitor: "48\"", monitor_standing: "62.5\"" },
    "5'6": { sitting: "25\"", standing: "40.5\"", chair: "17.5\"", monitor: "48.5\"", monitor_standing: "63.5\"" },
    "5'7": { sitting: "25\"", standing: "41\"", chair: "18\"", monitor: "49\"", monitor_standing: "64\"" },
    "5'8": { sitting: "25.5\"", standing: "41.5\"", chair: "18\"", monitor: "49.5\"", monitor_standing: "64.5\"" },
    "5'9": { sitting: "26\"", standing: "42.5\"", chair: "18.5\"", monitor: "50\"", monitor_standing: "65.5\"" },
    "5'10": { sitting: "26.5\"", standing: "43\"", chair: "18.5\"", monitor: "50.5\"", monitor_standing: "66\"" },
    "5'11": { sitting: "27\"", standing: "43.5\"", chair: "19\"", monitor: "51\"", monitor_standing: "66.5\"" },
    "6'0": { sitting: "27\"", standing: "44\"", chair: "19\"", monitor: "51.5\"", monitor_standing: "67\"" },
    "6'1": { sitting: "27.5\"", standing: "44.5\"", chair: "19.5\"", monitor: "52\"", monitor_standing: "67.5\"" },
    "6'2": { sitting: "28\"", standing: "44.5\"", chair: "19.5\"", monitor: "52.5\"", monitor_standing: "67.5\"" },
    "6'3": { sitting: "28.5\"", standing: "46\"", chair: "20\"", monitor: "53\"", monitor_standing: "69\"" },
    "6'4": { sitting: "28.5\"", standing: "47\"", chair: "20\"", monitor: "53.5\"", monitor_standing: "70\"" },
    "6'5": { sitting: "29\"", standing: "47.5\"", chair: "20.5\"", monitor: "54\"", monitor_standing: "70.5\"" },
    "6'6": { sitting: "29\"", standing: "48\"", chair: "20.5\"", monitor: "54.5\"", monitor_standing: "71\"" },
    "6'7": { sitting: "29.5\"", standing: "49\"", chair: "21\"", monitor: "55\"", monitor_standing: "72\"" },
    "6'8": { sitting: "30\"", standing: "49.5\"", chair: "21\"", monitor: "55.5\"", monitor_standing: "72.5\"" }
  };
  
  const $parentSectionEl = $(this).closest('.height-calculator-wrapper');
  const $resultsEl = $parentSectionEl.find('.results');
  const $result_desk_heightEl = $resultsEl.find('#result_desk_height');
  const $result_monitor_heightEl = $resultsEl.find('#result_monitor_height');
  const $result_chair_heightEl = $resultsEl.find('#result_chair_height');
  const $sectionImagesArr = $parentSectionEl.find('.height-calculator-image');
  const $empty_resultEl = $parentSectionEl.find('.empty_result');
  const $results_chair_blockEl = $resultsEl.find('.results_chair_block');
  
  const heightVal = $parentSectionEl.find('.heightSelector').val();
  const positionVal = $parentSectionEl.find('.positionSelector').val();
  
  $sectionImagesArr.addClass('hide');
  const $activeImageEl = $parentSectionEl.find(`.${positionVal}_image`);
  
  if($activeImageEl.length) {
    $activeImageEl.removeClass('hide');
  }
    
  if (heightData[heightVal]) {
    $result_chair_heightEl.html(heightData[heightVal].chair);
      if(positionVal == 'sitting') {
        $results_chair_blockEl.removeClass('hide');
        $result_desk_heightEl.html(heightData[heightVal].sitting);
        $result_monitor_heightEl.html(heightData[heightVal].monitor);
      } else {
        $results_chair_blockEl.addClass('hide');
        $result_desk_heightEl.html(heightData[heightVal].standing);  
        $result_monitor_heightEl.html(heightData[heightVal].monitor_standing);
      }
    
    $resultsEl.removeClass('hide');
    $empty_resultEl.addClass('hide');
  } else {
     $resultsEl.addClass('hide');
      $empty_resultEl.removeClass('hide');
  }
  
  });
  $('body').on('change','.height-calculator-select.positionSelector', function(e) {
  e.preventDefault();
    const $parentSectionEl = $(this).closest('.height-calculator-wrapper');
    const $sectionImagesArr = $parentSectionEl.find('.height-calculator-image');
    const positionVal = $(this).val();
    
    $sectionImagesArr.addClass('hide');
  const $activeImageEl = $parentSectionEl.find(`.${positionVal}_image`);
     if($activeImageEl.length) {
    $activeImageEl.removeClass('hide');
  }
    
  });

  $('body').on('change','.infographic_section-swatch',function(e) {
    const $sectionWrapperEl  = $(this).closest('.infographic_section-wrap');
    const $sectionImageEl = $sectionWrapperEl.find('.infographic_section-image-wrapper img');
    const $sectionButtonEl = $sectionWrapperEl.find('.infographic_section-info-btn');

    const new_image_url = $(this).attr('data-image-url');
    const new_btn_link = $(this).attr('data-btn-link');

    $sectionImageEl.attr('src',new_image_url);
    $sectionImageEl.attr('srcset',new_image_url);
    $sectionButtonEl.attr('href',new_btn_link);
  });
  $('body').on('click','.anchor_link_item', function(e) {
    if(!$(this).hasClass('full-unstyled-link')) {
    e.preventDefault();

    let scrollProgressBtn = false;
    let parentEl =  $(this).closest('.anchor_links_nav_section') || $(this).closest('.scroll_bar_nav__section');

    if(parentEl.length == 0) {
      parentEl =  $(this).closest('.scroll_bar_nav__section');
      scrollProgressBtn = true;
    }

      parentEl.find('.anchor_link_item').removeClass("active");
      $(this).addClass("active");
      const target = $(this).data('target');
      const is_tabs_mode = $(this).closest('.tabs_mode');
      const anchor_links_nav_section_wrapperEl = $(this).closest('.anchor_links_nav_section_wrapper');

      const header_height = parseFloat(document.documentElement.style.getPropertyValue('--header-height'));
      const announcement_bar_height = parseFloat(document.documentElement.style.getPropertyValue('--announcement-bar-height'));
      const section_height = parentEl.height() || 0;

      if(is_tabs_mode.length && parentEl.length) {
        
        const $anchor_nav_dividerEl = $('.anchor_nav_divider_tab[data-anchor_id="' + target + '"]');
        if($anchor_nav_dividerEl.length) {
          const $anchor_nav_divider_section = $anchor_nav_dividerEl.closest('.anchor_nav_divider_section');
          
          const $prev_anchor_nav_divider_section = $anchor_nav_divider_section.prevAll('.anchor_nav_divider_section').first();
            
            if($prev_anchor_nav_divider_section.length) {
              const $prev_active_sections = $prev_anchor_nav_divider_section.nextUntil('.anchor_nav_divider_section');
             
              if($prev_active_sections.length) {
                $prev_active_sections.addClass('hideTabSection');
                $prev_active_sections.removeClass('activeTabSection');
                
              }
            } else {
              $('.activeTabSection').addClass('hideTabSection').removeClass('activeTabSection');
            }
          
          const $tabSections = $anchor_nav_divider_section.nextUntil('.anchor_nav_divider_section');
            if($tabSections.length) {
              $tabSections.removeClass('hideTabSection');
              $tabSections.addClass('activeTabSection');
            }

        const parentNodeEl = anchor_links_nav_section_wrapperEl[0].parentNode;
          if (anchor_links_nav_section_wrapperEl[0] == parentNodeEl.firstElementChild) {
              $("html, body").animate({
               scrollTop: 0
              }, 1e3);
          } else {
              $("html, body").animate({
               scrollTop: (header_height - section_height)
              }, 1e3);
          }         
          
        }
      } else {  

         
      let scrollPosition = $(target).offset().top - header_height - section_height - announcement_bar_height;
        if(scrollProgressBtn) {
          scrollPosition = scrollPosition - 90;
        }
        
        $("html, body").animate({
        scrollTop: (scrollPosition)
        }, 1e2);
      }     
  }
  });
  if( $('.anchor_links_nav_section').length) {
    function ScrollAnchorNavProgress() {
      const parentEl = $('.anchor_links_nav_section');
      
      const header_height = parseFloat(document.documentElement.style.getPropertyValue('--header-height'));
      const announcement_bar_height = parseFloat(document.documentElement.style.getPropertyValue('--announcement-bar-height'));
      const section_height = parentEl.height() || 0;
      const windowY = window.scrollY;
      const window_scroll_with_sticky_elems = windowY+header_height+announcement_bar_height+section_height;

      const $anchor_points__nav_items = parentEl.find('.anchor_link_item');
      $anchor_points__nav_items.each(function(i) {
         const target = $(this).data('target');
          if ($(target).offset().top <= window_scroll_with_sticky_elems) {
            $anchor_points__nav_items.removeClass('active');
            $(this).addClass('active');
          } else {
            return false;
          }
      });
      
    }
    window.addEventListener('scroll', ScrollAnchorNavProgress);   
  }
  
});